export default __webpack_public_path__ + "static/media/social-2.92bffa9f.png";